import { useState } from 'react';
import type { TachInfo } from '../../api';
import { formatMetric } from '../../utils/formatMetric';
import ReplaceTachometerModal from '../ReplaceTachometerModal/ReplaceTachometerModal';
import './TachometerCard.css';

type Props = {
  tachInfo: TachInfo | null;
  canMaintain: boolean;
  onReplaced: (info: TachInfo) => void;
};

const TachometerCard = ({ tachInfo, canMaintain, onReplaced }: Props) => {
  const [showReplace, setShowReplace] = useState(false);
  const value = formatMetric(tachInfo?.tach_current);
  const moto = formatMetric(tachInfo?.motohours_tip);

  return (
    <div className="aircraft-hub-card is-static tach-hub-card">
      <span className="aircraft-hub-label">Тахометр</span>
      <span className="aircraft-hub-value">
        <span className="aircraft-hub-number">
          {value}
          {value !== '—' ? (
            <span className="aircraft-hub-unit">м/ч</span>
          ) : null}
        </span>
      </span>
      <div className="tach-hub-meta">
        <span className="aircraft-hub-footer">Моточасы: {moto} м/ч</span>
        {canMaintain ? (
          <button
            type="button"
            className="tach-hub-replace"
            onClick={() => setShowReplace(true)}
          >
            Заменить тахометр
          </button>
        ) : null}
      </div>
      {showReplace ? (
        <ReplaceTachometerModal
          onClose={() => setShowReplace(false)}
          onReplaced={onReplaced}
        />
      ) : null}
    </div>
  );
};

export default TachometerCard;
